import { Log, Level, Logger } from 'ng2-logger';
import { Common } from '../core/common';
import { ApiTypes } from '../models/enums/ApiTypes';

const _logger = Log.create('ALMS-Api');
let _common: Common;

function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export default class ApiClient {
    constructor() {
        _common = new Common();
    }

    public RequestAsync(
        method: string = 'GET',
        path: string,
        data: any = null,
        bearerToken: string = '',
        byPassWaitToken: boolean = false,
        type: ApiTypes = ApiTypes.None,
        mockApiUrl = ''
    ): Promise<Response> {
        let bToken: string | null = '';
        let currentCulture: string = 'tr-TR';
        if (_common.GetAuthLocalStorage()) {
            bToken = _common.GetAuthLocalStorage().access_token;
        }
        let localStorageCulture = _common.GetUserCulture();
        if(localStorageCulture){
            currentCulture = localStorageCulture;
        }

        path = path.replace('//', '/');

        if (!path.startsWith('/')) {
            path = '/' + path;
        }

        let baseApiUrl = type === ApiTypes.Background ? window.appSettings.BACKGROUND_API_URL : window.appSettings.API_URL;

        if (mockApiUrl) {
            baseApiUrl = mockApiUrl;
        }
        if (mockApiUrl) {
            if (method.toUpperCase() === 'GET') {
                _logger.data('body data:', data);
                return fetch(mockApiUrl, {
                    redirect: 'follow',
                    method, // EMPTY BODY ERROR
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + bToken //401 error fixed
                    }
                });
            } else {
                return fetch(mockApiUrl, {
                    redirect: 'follow',
                    method, // EMPTY BODY ERROR
                    headers: {
                        'Content-Type': 'application/json', //401 error fixed
                        Authorization: 'Bearer ' + bToken
                    }
                });
            }
        } else {
            return fetch(baseApiUrl + path, {
                redirect: 'follow',
                method,
                body: method.toUpperCase() === 'GET' ? null : data === null ? null : JSON.stringify(data),
                headers: {
                    pragma: 'no-cache',
                    'cache-control': 'no-cache',
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: 'Bearer ' + bToken,
                    'Accept-Language': currentCulture
                }
            });
        }
    }

    // public insertGraylogMessage = async (userGuid: string, userFullName: string, data: any) => {
    //     const timeout = 2000;
    //     data.requestUrlHost = window.location.host;
    //     data.requestUrlPathName = window.location.pathname;
    //     data.userGuid = userGuid;
    //     data.userFullName = userFullName;

    //     const controller = new AbortController();
    //     const id = setTimeout(() => controller.abort(), timeout);
    //     const response = await fetch(window.appSettings.GRAYLOG_SERVER, {
    //         method: 'POST',
    //         body: data === null ? null : JSON.stringify(data),
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         signal: controller.signal
    //     });
    //     clearTimeout(id);
    //     return response;
    // };

    public MockRequestAsync(
        method: string = 'GET',
        path: string,
        data: any = null,
        bearerToken: string = '',
        byPassWaitToken: boolean = false
    ): Promise<Response> {
        let bToken: string | null = '';
        if (_common.GetAuthLocalStorage()) {
            bToken = _common.GetAuthLocalStorage().access_token;
        }

        return fetch('http://localhost:4000/' + path, {
            redirect: 'follow',
            method,
            body: data === null ? null : JSON.stringify(data),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                // 'Access-Control-Allow-Origin': '*',
                Authorization: 'Bearer ' + bToken
            }
        });
    }
}
